// [2026-09-22 운영자 지시] 관리자 대시보드 접속자 현황에 "온라인 회원이 어느 페이지에 있는지" 를 보여 주기 위해
//   화면 경로가 바뀔 때마다(그리고 접속·재접속 뒤) 유저 API 에 현재 경로를 알린다(socket 이벤트 presence:page, 경로만 보낸다).
//   - 소켓은 로그인 확인 뒤(useAuth) 나중에 연결되고 재접속 때는 소켓 객체가 새로 만들어지므로 "이벤트 리스너 한 번 등록" 방식은
//     연결 전에 등록되면 사라진다(실측: 첫 구현이 그래서 한 번도 보내지 못했다). 그래서 1초마다 살펴보며 "지금 연결된 소켓 객체"에
//     아직 안 보냈으면 보낸다 — 경로마다 소켓 객체당 1회, 연결이 없으면 아무것도 보내지 않는다(로그인 전 화면).
//   - 화면 이름은 관리자 쪽(대시보드)이 붙인다. 6 디자인 공통 파일(내용 동일). 소켓 서비스의 socket/connected/emit 이름은 6 디자인이 같다.
import { useEffect } from 'react';
import socketService from '../services/socket';

const CHECK_MS = 1000;

export default function usePresencePageReport(pathname) {
  useEffect(() => {
    if (typeof pathname !== 'string' || !pathname) return undefined;
    let reportedTo = null; // 이 경로를 이미 알린 소켓 객체
    const tick = () => {
      const s = socketService.socket;
      if (!s || !socketService.connected) { reportedTo = null; return; }
      if (reportedTo === s) return;
      try { socketService.emit('presence:page', { path: pathname }); reportedTo = s; } catch (_) { /* 연결 전·끊김 — 다음 확인 때 다시 */ }
    };
    tick();
    const timer = setInterval(tick, CHECK_MS);
    return () => clearInterval(timer);
  }, [pathname]);
}
